import { render } from "./ShopifySso.vue?vue&type=template&id=380967b6&scoped=true"
import script from "./ShopifySso.vue?vue&type=script&lang=ts"
export * from "./ShopifySso.vue?vue&type=script&lang=ts"

import "./ShopifySso.vue?vue&type=style&index=0&id=380967b6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-380967b6"

export default script